var nameList = [
  "Rohan Mehta",
  "Ayesha Sharma",
  "Kunal Desai",
  "Priya Verma",
  "Richa Kaushik",
  "Tushar Parekh",
  "Sonali Deshmukh",
  "Rajat Talwar",
  "Kavya Pillai",
  "Nitin Batra",
  "Shreya Nair",
  "Abhishek Joshi",
  "Supriya Mehra",
  "Parth Jha",
  "Tanvi Shukla",
  "Harish Mistry",
  "Akriti Bhatia",
  "Arnav Kumar",
  "Shalini Jain",
  "Rajesh Srivastava",
  "Divya Rana",
  "Dev Patel",
  "Anjali Aggarwal",
  "Vishal Khanna",
  "Aishwarya Prasad",
  "Nikhil Ghosh",
  "Pallavi Mishra",
  "Dhruv Bhatnagar",
  "Simran Bajaj",
  "Krishnakant Tiwari",
  "Parul Chopra",
  "Sanjay Kapoor",
  "Tamanna Sood",
  "Amit Chatterjee",
  "Avantika Pandey",
  "Alok Bansal",
  "Riya Sengupta",
  "Abhinav Tyagi",
  "Bhavya Rao",
  "Mohan Shetty",
  "Ritika Desai",
  "Abhay Verma",
  "Sakshi Khurana",
  "Naveen Gupta",
  "Mahima Roy",
  "Jai Sinha",
  "Ira Bhandari",
  "Hitesh Jain",
  "Ankita Sinha",
  "Tarun Reddy",
  "Priyanka Gupta",
  "Yuvraj Chauhan",
  "Shraddha Pillai",
  "Lokesh Singh",
  "Sakshi Anand",
  "Sudhir Bhargava",
  "Anjali Nair",
  "Nitin Kulkarni",
  "Shivani Sharma",
  "Arvind Prasad",
  "Asha Mehta",
  "Anil Rao",
  "Sneha Kapoor",
  "Vishnu Menon",
  "Karishma Yadav",
  "Rahul Thakur",
  "Ankita Verma",
  "Manoj Pillai",
  "Rashi Gupta",
  "Nilesh Deshmukh",
  "Tamanna Shukla",
  "Sameer Choudhary",
  "Ridhima Mehra",
  "Deepak Chauhan",
  "Shruti Bhatia",
  "Abhijeet Sharma",
  "Payal Gupta",
  "Shyam Agarwal",
  "Isha Jain",
  "Rajiv Soni",
  "Prachi Iyer",
  "Abhinav Gupta",
  "Meena Sharma",
  "Sandeep Malhotra",
  "Divya Iyer",
  "Gaurav Jain",
  "Sonal Kulkarni",
  "Amit Joshi",
  "Swati Desai",
  "Harsh Bhatia",
  "Neha Reddy",
  "Rajesh Mehra",
  "Pallavi Shah",
  "Arjun Nair",
  "Ritu Kapoor",
  "Kunal Sharma",
  "Pooja Bhatia",
  "Vikram Khanna",
  "Ishita Reddy",
  "Saurabh Mehta",
  "Aditi Verma",
  "Rakesh Goyal",
  "Shalini Agarwal",
  "Nitin Prasad",
  "Supriya Mehra",
  "Varun Desai",
  "Nisha Sinha",
  "Rajiv Jain",
  "Priya Malhotra",
  "Tushar Bhardwaj",
  "Kavita Patel",
  "Yash Sharma",
  "Suman Ghosh",
  "Akshay Choudhary",
  "Megha Nair",
  "Rohan Deshmukh",
  "Shruti Reddy",
  "Anuj Kapoor",
  "Karishma Joshi",
  "Vikas Sharma",
  "Sneha Iyer",
  "Amit Mehta",
  "Ankita Bhatnagar",
  "Gaurav Patel",
  "Aishwarya Deshmukh",
  "Manish Jain",
  "Kavita Agarwal",
  "Sandeep Singh",
  "Swati Rao",
  "Vivek Sharma",
  "Priyanka Patel",
  "Vishal Kumar",
  "Poonam Sharma",
  "Karan Desai",
  "Isha Kapoor",
  "Amit Bansal",
  "Neha Malhotra",
];

var msgList = [
  "Nice stream, really enjoying it! 🙌",
  "Amazing quality, keep it up! 💯",
  "Yes, you're absolutely right! 👍",
  "I love your content, always so engaging! ❤️",
  "This is so entertaining, great job! 🎉",
  "Totally agree with what you said! 👏",
  "Wow, this is awesome! 🔥",
  "Your energy is contagious! 😄",
  "Loving the vibes here! ✨",
  "Great points, thanks for sharing! 💡",
  "This stream is on fire! 🔥",
  "Keep up the amazing work! 💪",
  "You’re doing great, love it! 🙌",
  "Such valuable content, thank you! 🙏",
  "This is super interesting, thanks for the insights! 🧠",
  "Loving this discussion, so informative! 🗣️",
  "You’re so talented, wow! 🌟",
  "This stream just made my day! 😍",
  "Yes, I completely agree! 👍",
  "Thanks for answering my question! 🙏",
  "Great advice, I’m taking notes! 📝",
  "This is the best part of my day! 🥳",
  "You're so right about that! 💯",
  "Such a fun stream, thank you! 🎉",
  "Your content always brightens my day! ☀️",
  "This is exactly what I needed to hear! 🙌",
  "So glad I tuned in, amazing content! 📺",
  "You always keep it real, love that! ❤️",
  "This conversation is pure gold! 🏆",
  "I’m learning so much from this! 📚",
  "You’ve got such a positive vibe! 🌈",
  "This stream is everything! 🔥",
  "I’m loving every minute of this! ⏰",
  "You’re killing it, as always! 💪",
  "Such an inspiration, keep it up! 🌟",
  "Thanks for all the hard work you put into this! 🙏",
  "This stream is next level! 🚀",
  "Your streams are always so insightful! 🧠",
  "I can’t get enough of your content! 😍",
  "This is the highlight of my day! 🌟",
  "You’re doing an amazing job, keep it up! 👏",
  "This is so fun to watch! 😄",
  "I’m so glad I found this stream! 🎉",
  "Your content is always top-notch! 💯",
  "So many great takeaways from this stream! 📝",
  "This is so motivating, thank you! 💪",
  "You’ve got such a unique perspective, love it! 🌟",
  "Every time I watch, I learn something new! 🧠",
  "You never disappoint, amazing stream! 👌",
  "So many great points being made here! 💡",
  "This content is gold, thanks for sharing! 🏆",
  "I always look forward to your streams! 🎉",
  "This is exactly what I needed today! ☀️",
  "You’re so relatable, love your authenticity! ❤️",
  "This stream is just getting better and better! 🔥",
  "I’m hooked, can’t stop watching! 😍",
  "Thanks for being so real and down-to-earth! 🙏",
  "This is definitely worth the time, great content! 🕒",
  "You’re doing such a great job, keep it up! 💪",
  "This is so refreshing, love the positivity! 🌈",
  "I can’t believe how much I’m learning! 📚",
  "You’ve got such a great community here! 👥",
  "This stream is such a mood booster!",
  "You’re a natural at this, so good!",
  "This content is so valuable, thank you!",
  "Every time I watch, I feel inspired!",
  "This stream is hitting all the right notes!",
  "Your streams are always so well done!",
  "I love how engaging this is!",
  "This is the kind of content I need!",
  "You’re doing an amazing job, keep it up!",
  "This is such a great conversation, thank you!",
  "I can’t wait to see what’s next!",
  "This stream is seriously impressive!",
  "I’m learning so much from this!",
  "This is exactly what I needed to hear today!",
  "You’ve got such a great approach, love it!",
  "This content is so refreshing!",
  "I’m so glad I didn’t miss this stream!",
  "This is the kind of content I live for!",
  "Your streams are always a highlight for me!",
  "This is so engaging, love it! 👍",
  "You’ve got such a unique style, keep it up!",
  "This is so informative, thank you! 📝",
  "I’m really enjoying this conversation!",
  "This stream is absolutely amazing! 🌟",
  "You always know how to make things interesting!",
  "This is such a valuable discussion! 💡",
  "I’m so glad I found this stream!",
  "This content is pure gold! 🏆",
  "You’re doing such a great job, keep going!",
  "This is so much fun, thanks for the laughs! 😂",
  "You’ve got such a great community here!",
  "This is exactly what I was looking for! 🔍",
  "I can’t wait to see more from you! 🚀",
  "This stream is so well done, love it! 🌟",
  "You’re always on point with your content!",
  "This is so inspiring, thank you! 🙏",
  "I’m loving the positivity in this stream! 🌈",
  "This is the best part of my day, thank you! ☀️",
];

var images = [
  "https://images.unsplash.com/photo-1438761681033-6461ffad8d80",
  "https://images.unsplash.com/photo-1534528741775-53994a69daeb",
  "https://images.unsplash.com/photo-1524504388940-b1c1722653e1",
  "https://images.unsplash.com/photo-1526413232644-8a40f03cc03b",
  "https://images.unsplash.com/photo-1567160702099-5a0f932bad59",
  "https://images.unsplash.com/photo-1544243747-b8ca15da2450",
  "https://images.unsplash.com/photo-1527565290982-018bcfdbee74",
  "https://images.unsplash.com/photo-1608649672403-3609a75eae18",
  "https://images.unsplash.com/photo-1608127010599-43d44ab72bb1",
  "https://images.unsplash.com/photo-1560250097-0b93528c311a",
  "https://images.unsplash.com/photo-1493612276216-ee3925520721",
  "https://images.unsplash.com/photo-1508138221679-760a23a2285b",
  "https://images.unsplash.com/photo-1501426026826-31c667bdf23d",
  "https://images.unsplash.com/photo-1506277886164-e25aa3f4ef7f",
  "https://images.unsplash.com/photo-1503249023995-51b0f3778ccf",
  "https://images.unsplash.com/photo-1499996860823-5214fcc65f8f",
  "https://images.unsplash.com/photo-1473172707857-f9e276582ab6",
  "https://images.unsplash.com/photo-1511551203524-9a24350a5771",
];

export const btnList = [
  // {
  //   btnName: "All",
  //   id: "",
  //   url: "/",
  // },
  {
    btnName: "Auto & Vehicles",
    id: "2",
    url: "/?v=2",
  },

  {
    btnName: "Music",
    id: "10",
    url: "/?v=10",
  },
  {
    btnName: "Pets & Animals",
    id: "15",
    url: "/?v=15",
  },
  {
    btnName: "Sports",
    url: "/?v=17",
  },
  {
    btnName: "Gaming",
    url: "/?v=20",
  },
  {
    btnName: "People & BLogs",
    url: "/?v=22",
  },
  {
    btnName: "Comedy",
    url: "/?v=23",
  },
  {
    btnName: "Entertainment",
    url: "/?v=24",
  },
  {
    btnName: "News & Politics",
    url: "/?v=25",
  },
  {
    btnName: "Science & Technology",
    url: "/?v=28",
  },
];

export function generateRandomName() {
  return nameList[Math.floor(Math.random() * nameList.length)];
}

export function makeRandomMessage() {
  return msgList[Math.floor(Math.random() * msgList.length)];
}

export function generateRandomImg() {
  return images[Math.floor(Math.random() * images.length)];
}
